'use strict'

// safari polyfills for react 16
import 'core-js/es6/map'
import 'core-js/es6/set'

import React from 'react'
import { createRoot } from 'react-dom/client'
import { Router, Route, Switch } from 'react-router-dom'
import { Provider } from 'react-redux'

import AppRouter from './router'
import NotFound from './helper/not_found'

import TidewaysRoute from './app/route'

import Dashboard from './dashboard'
import Monitor from './monitor'
import RouteAwareSnapshot from './monitor/route-aware-snapshot'
import CompareRange from './monitor/compareRange/view'

import Operation from './operation'
import ProfileList from './profile-list'
import Errors from './errors'
import History from './history-new'
import Trace from './trace'
import TriggerTrace from './trigger-trace'
import TraceDiff from './trace_diff'

import { TidewaysContext } from './app/context'

import Loader from './app/loader'
import store from './app/store'
import history from './app/history'
import { parseQueryString } from './helper/queryString'
import TransactionHistory from './history/transaction'
import { RecentlyViewedByYouScreen } from './recently-viewed-by-you-screen'
import { TracepointList } from './tracepoint-list'
import { TracepointDetails } from './tracepoint-details'
;(function(jQuery) {
    jQuery.fn.app = function(options) {
        jQuery.extend({}, jQuery.fn.app.defaults, options)

        return jQuery(this).each(function() {
            let container = jQuery(this)[0]
            const root = createRoot(container)
            let appData = jQuery(container).data('app')
            let tidewaysContext = new TidewaysContext(appData.tidewaysContext)
            let router = new AppRouter(history, appData.routes, tidewaysContext, appData.user)
            let previousLocation = null

            store.dispatch({ type: 'TIDEWAYS_INIT', tidewaysContext: tidewaysContext, router: router })
            let loader = new Loader(store, router)
            history.listen(location => {
                loader.loadContentForPath(location.pathname, parseQueryString(history.location.search), previousLocation?.pathname)
                previousLocation = location
            })
            loader.loadContentForPath(history.location.pathname, parseQueryString(history.location.search))

            const projectLandingPageComponent = tidewaysContext.isProfilingSpace() ? ProfileList : Monitor

            root.render(
                <Provider store={store}>
                    <Router history={history}>
                        <Switch>
                            {TidewaysRoute(router, 'dashboard', Dashboard)}

                            {TidewaysRoute(router, 'XhprofOrganizationBundle.Application.show', projectLandingPageComponent)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.CompareRange.show', CompareRange)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Snapshot.show', RouteAwareSnapshot)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.OperationSnapshot.show', Operation)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Transaction.show', Operation, { router: router })}

                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.list', ProfileList)}

                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.listTracesHistory', RecentlyViewedByYouScreen)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.listTracepoints', TracepointList)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.tracepoint', TracepointDetails)}

                            {TidewaysRoute(router, 'XhprofErrorBundle.Issues.errors', Errors, { level: 'error' })}
                            {TidewaysRoute(router, 'XhprofErrorBundle.Issues.deprecations', Errors, { level: 'deprecated' })}
                            {TidewaysRoute(router, 'XhprofErrorBundle.Issues.nonFatals', Errors, { level: 'non-fatals' })}
                            {TidewaysRoute(router, 'XhprofErrorBundle.Issues.slowSql', Errors, { level: 'slowsql' })}
                            {TidewaysRoute(router, 'XhprofErrorBundle.Issues.release', Errors, { level: 'release' })}
                            {TidewaysRoute(router, 'XhprofErrorBundle.Issues.incident', Errors, { level: 'incident' })}
                            {TidewaysRoute(router, 'XhprofErrorBundle.Issues.observation', Errors, { level: 'observation' })}

                            {TidewaysRoute(router, 'XhprofProfilerBundle.History.lastWeek', History)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.History.history', History)}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.History.operationHistory', TransactionHistory)}

                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.show', Trace, { view: 'timeline' })}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.quick', Trace, { view: 'timeline' })}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.summary', Trace, { view: 'summary' })}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.flamegraph', Trace, { view: 'flamegraph' })}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.bottlenecksReport', Trace, { view: 'bottlenecks' })}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.full', Trace, { view: 'calls' })}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.callgraph', Trace, { view: 'callgraph' })}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.callgraphNew', Trace, { view: 'callgraph' })}

                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.listCompare', Trace, { view: 'compare' })}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.compare', TraceDiff, { view: 'flamegraph' })}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.relatedTraces', Trace, { view: 'related-traces' })}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.logs', Trace, { view: 'logs' })}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.referencedTraces', Trace, { view: 'linked-traces' })}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.linkedTraces', Trace, { view: 'linked-traces' })}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.functionCompare', TraceDiff, { view: 'functions' })}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.callgraphCompare', TraceDiff, { view: 'callgraph' })}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.flamegraphCompare', TraceDiff, { view: 'flamegraph' })}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.summaryCompare', TraceDiff, { view: 'summary' })}
                            {TidewaysRoute(router, 'XhprofProfilerBundle.Profile.callsCompare', TraceDiff, { view: 'calls' })}
                            {TidewaysRoute(router, 'XhprofOrganizationBundle.Application.trigger', TriggerTrace)}

                            {/* If we do not handle URL yet, pass URL through Symfony stack */}
                            <Route component={NotFound} />
                        </Switch>
                    </Router>
                </Provider>,
            )
        })
    }
    jQuery.fn.app.defaults = {}
})(jQuery)

window.pluginRegistry.register({ selector: '[data-app]', invoke: 'app', isReact: true })
